import { format, isValid, parseISO } from 'date-fns';

/**
 * A futó build adatai. A build-stamp szkript írja az index.html meta tagjeibe.
 * Spec: docs/superpowers/specs/2026-09-16-app-update-detection-design.md (6., 7.1, 7.6, 9)
 */
export interface BuildInfo {
  readonly id: string;
  readonly commit: string;
  readonly builtAt: string;
}

const TRANSLATION_FILE_EXTENSION = '.json';
const BUILD_TIME_FORMAT = 'yyyy-MM-dd HH:mm';
const LABEL_SEPARATOR = ' · ';

const metaContent = (doc: Document, name: string): string => doc.querySelector(`meta[name="${name}"]`)?.getAttribute('content')?.trim() ?? '';

/** Fejlesztői szerveren és build-stamp nélküli buildnél null: ilyenkor a frissítés-figyelő nem indul. */
export function readBuildInfo(doc: Document): BuildInfo | null {
  const id = metaContent(doc, 'app-build-id');
  if (!id) {
    return null;
  }
  return { id, commit: metaContent(doc, 'app-build-commit'), builtAt: metaContent(doc, 'app-build-time') };
}

/** A fordítás-fájlok címe a build-azonosítót is tartalmazza, így új build után nem jöhet régi fordítás. */
export const translationFileSuffix = (info: BuildInfo | null): string =>
  info ? `${TRANSLATION_FILE_EXTENSION}?v=${encodeURIComponent(info.id)}` : TRANSLATION_FILE_EXTENSION;

/** A lábléc kiegészítése, pl. „ · 364a113b · 2026-09-16 18:40”; build-infó nélkül üres. */
export function formatBuildLabel(info: BuildInfo | null): string {
  if (!info) {
    return '';
  }
  const builtAt = parseISO(info.builtAt);
  const parts = [info.commit || info.id, isValid(builtAt) ? format(builtAt, BUILD_TIME_FORMAT) : ''];
  return parts
    .filter((part) => part !== '')
    .map((part) => `${LABEL_SEPARATOR}${part}`)
    .join('');
}
